import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Col,
  Row,
  Table,
  Message,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
} from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc'
import { MenuOutlined } from '@ant-design/icons'
import {
  getCategories,
  newOrEditCategory,
  deleteCategory,
  dragCategory,
} from '../../../api/businessCommodity'
import {
  fetchPrinterList,
  bindingPrinter,
  fetchCategoryBinding,
} from '../../../api/printer'
import CommodityDetail from '../components/commodityDetail'
import record from '../../ClubTableStatus/component/record'

class Categories extends React.Component {
  state = {
    club_id: '',
    categoryList: [],
    isVisible: false,
    confirmLoading: false,
    title: '',
    name: '',
    order: '',
    id: '',
    modalState: '',
    printerList: [],
    selectedPrinter: [],
  }

  constructor(props) {
    super(props)
    // this.CommodityDetailRef = React.createRef()
  }

  componentDidMount() {
    this.getCategoryList()
    this.getClubPrinterList()
  }

  getCategoryList = async () => {
    const club_id = sessionStorage.getItem('club_id')
    const { data, status, detail } = await getCategories(club_id)
    if (status == 1) {
      this.setState({ categoryList: data })
    } else {
      Message.error(detail)
    }
  }

  onOk = async () => {
    const { modalState, name, order, id } = this.state
    if (name) {
      this.setState({ confirmLoading: true })
      const params = {
        name: name,
      }
      if (modalState == 'modify') {
        params.order = order
        params.id = id
      }
      const { data, status, detail } = await newOrEditCategory(params)
      if (status == 1) {
        this.getCategoryList()
        this.bindingPrinters(data[0])
        // this.setState({
        //   confirmLoading: false,
        //   isVisible: false,
        // })
        Message.success('操作成功')
      } else {
        Message.error(detail)
      }
    } else {
      Message.error('请填写分类名称')
    }
  }

  onCancel = () => {
    this.setState({
      isVisible: false,
      name: '',
      order: '',
      id: '',
      selectedPrinter: [],
    })
  }

  showModal = (title, record) => {
    this.setState({
      title: title,
      isVisible: true,
      modalState: 'new',
    })
    if (record) {
      this.categoryBinding(record.id)
      this.setState({
        modalState: 'modify',
        name: record.name,
        order: record.order,
        id: record.id,
      })
    }
  }

  deleteCategories = async (record) => {
    const ids = []
    ids.push(record.id)
    const { data, status, detail } = await deleteCategory({ ids: ids })
    if (status == 1) {
      this.getCategoryList()
      Message.success('删除成功')
    } else {
      Message.error(detail)
    }
  }

  draggedList = async (source, offset) => {
    const { data, status, detail } = await dragCategory({
      source,
      offset,
    })
    if (status == 1) {
      this.getCategoryList()
      Message.success('操作成功')
    } else {
      Message.error(detail)
    }
  }

  arrayMoveMutable = (array, fromIndex, toIndex) => {
    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex

    if (startIndex >= 0 && startIndex < array.length) {
      const endIndex = toIndex < 0 ? array.length + toIndex : toIndex

      const item = array.splice(fromIndex, 1)[0]
      array.splice(endIndex, 0, item)
    }
  }

  arrayMoveImmutable = (array, fromIndex, toIndex) => {
    const newArray = [...array]
    this.arrayMoveMutable(newArray, fromIndex, toIndex)
    return newArray
  }

  // 获取俱乐部小票机列表
  getClubPrinterList = async () => {
    const clubId = sessionStorage.getItem('club_id')
    const { data, status, detail } = await fetchPrinterList({
      clubId,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({
      printerList: data,
    })
  }

  // 商品分类绑定小票机
  bindingPrinters = async (id) => {
    const { selectedPrinter, printerList } = this.state
    let selectedObj = {}
    printerList.length > 0 &&
      printerList.map((item, index) => {
        if (selectedPrinter.indexOf(item.id) >= 0) {
          selectedObj[item.id] = true
        } else {
          selectedObj[item.id] = false
        }
      })
    const { data, status, detail } = await bindingPrinter({
      commodityCategoryId: id,
      printers: selectedObj,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({
      confirmLoading: false,
      // isVisible: false,
      selectedPrinter: [],
    })
    this.onCancel()
  }

  // 分类关联小票机列表
  categoryBinding = async (id) => {
    const { data, status, detail } = await fetchCategoryBinding({
      categoryId: id,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    let arr = []
    data.length > 0 &&
      data.map((item, index) => {
        arr.push(item.printerId)
      })
    this.setState({
      selectedPrinter: arr,
    })
  }

  render() {
    const { printerList } = this.state

    const DragHandle = SortableHandle(() => (
      <MenuOutlined
        style={{
          cursor: 'grab',
          color: '#999',
        }}
      />
    ))
    const columns = [
      {
        title: '排序',
        dataIndex: 'sort',
        width: 60,
        className: 'drag-visible',
        render: () => <DragHandle />,
      },
      {
        title: '分类id',
        dataIndex: 'id',
        className: 'drag-visible',
      },
      {
        title: '分类名称',
        dataIndex: 'name',
      },
      {
        title: '操作',
        dataIndex: 'handle',
        render: (text, record, index) => {
          return (
            <div>
              <Button
                size="small"
                type="primary"
                style={{ marginRight: '20px' }}
                onClick={() => {
                  this.showModal('编辑分类', record)
                }}
              >
                编辑
              </Button>

              <Popconfirm
                title="确认要删除此分类？"
                onConfirm={() => {
                  this.deleteCategories(record)
                }}
                okText="是"
                cancelText="否"
              >
                <Button size="small" type="danger">
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]
    let datas = this.state.categoryList
    let oldDatas = []
    const SortableItem = SortableElement((props) => <tr {...props} />)
    const SortableBody = SortableContainer((props) => <tbody {...props} />)

    // const [dataSource, setDataSource] = useState(data)

    const onSortEnd = ({ oldIndex, newIndex }) => {
      const source = this.state.categoryList[oldIndex]
      const offset = newIndex - oldIndex
      if (offset == 0) {
        return
      }
      this.draggedList(source, offset)

      // if (oldIndex !== newIndex) {
      //   const newData = this.arrayMoveImmutable(
      //     datas,
      //     oldIndex,
      //     newIndex
      //   ).filter((el) => !!el)
      //   oldDatas = [...datas]
      //   this.draggedList(newData, oldDatas, oldIndex, newIndex)
      // }
    }

    const DraggableContainer = (props) => (
      <SortableBody
        useDragHandle
        disableAutoscroll
        helperClass="row-dragging"
        onSortEnd={onSortEnd}
        {...props}
      />
    )

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
      // function findIndex base on Table rowKey props and should always be a right array index
      const index = datas.findIndex((x) => x.id === restProps['data-row-key'])
      // const index = dataSource.findIndex((x) => x.index === restProps['data-row-key'])
      return <SortableItem index={index} {...restProps} />
    }
    return (
      <div>
        <Row>
          <Col span={12}>
            <Button
              type="primary"
              onClick={() => {
                this.showModal('添加分类')
              }}
            >
              添加分类
            </Button>
          </Col>
        </Row>
        <div style={{ margin: '10px 0' }}>* 长按按钮可拖动排序</div>
        <Table
          bordered
          // style={{ marginTop: '30px' }}
          size="small"
          pagination={false}
          dataSource={datas}
          columns={columns}
          rowKey="id"
          components={{
            body: {
              wrapper: DraggableContainer,
              row: DraggableBodyRow,
            },
          }}
        />

        <Modal
          visible={this.state.isVisible}
          title={this.state.title}
          onOk={this.onOk}
          onCancel={this.onCancel}
          confirmLoading={this.state.confirmLoading}
          // width="800px"
          // destroyOnClose={true}
        >
          <Form
            name="basic"
            labelCol={{
              span: 5,
            }}
            wrapperCol={{
              span: 19,
            }}
            labelAlign="left"
          >
            <Form.Item
              label={
                <span>
                  {/* <span className="color_red">* </span> */}
                  <span>名称</span>
                </span>
              }
            >
              {/* <Row gutter={8}>
                <Col span={14}> */}
              <Input
                value={this.state.name}
                onChange={(e) => this.setState({ name: e.target.value })}
                placeholder="请输入分类名称"
              />
              {/* </Col>
              </Row> */}
            </Form.Item>

            {/* <Form.Item
              label={
                <span>
                  <span>选择关联小票机</span>
                </span>
              }
            >
              <Select></Select>
            </Form.Item> */}

            <div style={{ fontSize: '14px', marginBottom: '10px' }}>
              选择关联小票机 :
            </div>
            <Checkbox.Group
              style={{
                width: '100%',
              }}
              value={this.state.selectedPrinter}
              onChange={(value) => {
                this.setState({
                  selectedPrinter: value,
                })
              }}
            >
              <Row>
                {printerList.length > 0 &&
                  printerList.map((item, index) => {
                    return (
                      <Col span={12} key={item.id}>
                        <Checkbox value={item.id}>{item.name}</Checkbox>
                      </Col>
                    )
                  })}
              </Row>
            </Checkbox.Group>
          </Form>
        </Modal>
      </div>
    )
  }
}
export default withRouter(Categories)



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/Categories/index.js